import { QueryClient, QueryKey } from 'react-query';

export async function refetchChangedQueries(
    queryClient: QueryClient,
    changedQueryKeys: QueryKey[]
): Promise<void> {
    await Promise.all(changedQueryKeys.map((queryKey) => queryClient.cancelQueries(queryKey)));
    await Promise.all(changedQueryKeys.map((queryKey) => queryClient.invalidateQueries(queryKey)));
}
